










































import { Component, Vue } from "vue-property-decorator";
import { Carousel, Slide } from 'vue-carousel';
@Component({
  components: {
    Carousel,
    Slide
  }
})
export default class Spa extends Vue {

}

